module.exports = __webpack_public_path__ + "img/frame (264).752f8231.jpg";